import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ENTITY_TYPE } from '../types/marker-types';

type SearchResults = {
    organizationIds: string[];
    companyIds: string[];
};

interface FilterStore {
    filter: string;
    setFilter: (filter: string) => void;

    category: ENTITY_TYPE | null;
    setCategory: (category: ENTITY_TYPE | null) => void;

    results: SearchResults | null;
    setResults: (results: SearchResults|null) => void;
    clearResults: () => void;
}

export const useFilterStore = create<FilterStore>()(
    devtools((set) => ({
        filter: "",
        setFilter: (filter: string) => set({ filter }),

        category: null,
        setCategory: (category: ENTITY_TYPE | null) => set({ category }),

        results: null,
        setResults: (results) => set({ results }),
        clearResults: () => set({ results: null }),
    }))
);